module.exports = {"baseUrl":"/cockpit-gateway/monitoring/restriction-configuration","port":8080,"preffix":"","services":{"find":"/find","save":"/save"}}